import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { ResponsiveContainer, AreaChart, Area } from 'recharts';
import { KPI } from '../types';
import { formatCurrency, formatNumber, formatPercentage } from '../utils/formatters';
interface KpiSectionProps {
  kpis: KPI[];
}
function Sparkline({
  data,
  color
}: {
  data: number[];
  color: string;
}) {
  const chartData = data.map((val, i) => ({
    value: val,
    index: i
  }));
  return <div className="h-12 w-24" data-id="element-295">
      <ResponsiveContainer width="100%" height="100%" data-id="element-296">
        <AreaChart data={chartData} data-id="element-297">
          <defs data-id="element-298">
            <linearGradient id={`gradient-${color}`} x1="0" y1="0" x2="0" y2="1" data-id="element-299">
              <stop offset="5%" stopColor={color} stopOpacity={0.3} data-id="element-300" />
              <stop offset="95%" stopColor={color} stopOpacity={0} data-id="element-301" />
            </linearGradient>
          </defs>
          <Area type="monotone" dataKey="value" stroke={color} strokeWidth={2} fillOpacity={1} fill={`url(#gradient-${color})`} isAnimationActive={false} data-id="element-302" />
        </AreaChart>
      </ResponsiveContainer>
    </div>;
}
export function KpiSection({
  kpis
}: KpiSectionProps) {
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-8" data-id="element-303">
      {kpis.map(kpi => {
      const isPositive = kpi.trendDirection === 'up';
      const isNegative = kpi.trendDirection === 'down';
      const trendColor = isPositive ? 'text-emerald-400' : isNegative ? 'text-rose-400' : 'text-slate-400';
      const sparklineColor = isPositive ? '#34d399' : isNegative ? '#fb7185' : '#94a3b8';
      let displayValue = '';
      if (kpi.format === 'currency') displayValue = formatCurrency(kpi.value as number);else if (kpi.format === 'short-currency') displayValue = formatCurrency(kpi.value as number, true);else displayValue = formatNumber(kpi.value as number);
      return <div key={kpi.id} className="glass-panel rounded-2xl p-5 flex flex-col justify-between" data-id="element-304">
            <div className="flex justify-between items-start mb-4" data-id="element-305">
              <h3 className="text-slate-400 text-sm font-medium" data-id="element-306">
                {kpi.title}
              </h3>
            </div>

            <div className="flex items-end justify-between" data-id="element-307">
              <div data-id="element-308">
                <div className="text-2xl font-bold text-white mb-1 tracking-tight" data-id="element-309">
                  {displayValue}
                </div>
                <div className={`flex items-center text-xs font-medium ${trendColor}`} data-id="element-310">
                  {isPositive && <TrendingUp className="w-3 h-3 mr-1" data-id="element-311" />}
                  {isNegative && <TrendingDown className="w-3 h-3 mr-1" data-id="element-312" />}
                  {!isPositive && !isNegative && <Minus className="w-3 h-3 mr-1" data-id="element-313" />}
                  {formatPercentage(kpi.trend)} MoM
                </div>
              </div>
              <Sparkline data={kpi.history} color={sparklineColor} data-id="element-314" />
            </div>
          </div>;
    })}
    </div>;
}